// Keycloak must return to the site root because the dashboard router is hash
// based and an OAuth redirect URI cannot carry that fragment. GrooveSell (and
// the other history-mode apps) store the page the person was trying to open in
// localStorage. Without this resume step, that callback always lands on the
// Groove.cm dashboard and the stored page is never opened.

const APP_ROOTS = [
  '/groovesell',
  '/groovemail',
  '/groovepages',
  '/groovemember',
  '/groovevideo',
  '/grooveblog',
  '/groovewebinar',
  '/grooveadmin',
  '/grooveembeds',
  '/static'
];

// Vendor GrooveSell routes stay behind the free-account gate. These are the
// history paths the GrooveSell router marks freeAccountAllowed.
const AFFILIATE_ROOTS = [
  '/groovesell/affiliates-dashboard',
  '/groovesell/billing',
  '/groovesell/vendors',
  '/groovesell/promo-tools',
  '/groovesell/cookie-setter',
  '/groovesell/affiliate-marketplace',
  '/groovesell/marketplace',
  '/groovesell/affiliate-tracking',
  '/groovesell/payments',
  '/groovesell/promos',
  '/groovesell/affiliate-settings',
  '/groovesell/bonuses',
  '/groovesell/sub-affiliates'
];

function matchesRoot(pathname, root) {
  return pathname === root || pathname.startsWith(`${root}/`);
}

export function isAuthReturnLanding(pathname, hash) {
  if (pathname !== '/' && pathname !== '/index.html') return false;
  if (!hash || hash === '#') return true;
  return hash.startsWith('#/login');
}

function allowedPath(pathname, restricted) {
  if (restricted) return AFFILIATE_ROOTS.some(root => matchesRoot(pathname, root));
  return APP_ROOTS.some(root => matchesRoot(pathname, root));
}

export function safeAppReturn(redirect, origin, restricted) {
  if (typeof redirect !== 'string' || !redirect || redirect.length > 2048) return null;
  let url;
  try {
    url = new URL(redirect, origin);
  } catch (_) {
    return null;
  }

  if (url.origin !== origin || url.username || url.password) return null;
  if (url.pathname === '/' || url.pathname === '/index.html') return null;
  if (url.pathname.includes('/login') || !allowedPath(url.pathname, restricted)) return null;

  return `${url.pathname}${url.search}${url.hash}`;
}

export function resumeStoredAppRedirect({
  redirect,
  origin,
  pathname,
  hash,
  restricted
}) {
  if (!isAuthReturnLanding(pathname, hash)) return null;
  return safeAppReturn(redirect, origin, restricted);
}
